<template>
  <div>
    <van-nav-bar
      :border="false"
      :title="'查'+agrTypeOptions[type].label"
      left-arrow
      @click-left="$router.back()"
    />
    <van-field v-model="form.search" label="关键字" placeholder="请输入关键字" clearable style="margin-top: 10px;" />
    <van-button type="primary" class="search-btn" round @click="handleSearch">
      查询
    </van-button>
    <agr-search-list :visible.sync="popup.list" :type="type" :extra-params="extraParams" />
  </div>
</template>

<script>
import { agrTypeOptions } from '@/constant/common'
import AgrSearchList from '@/views/More/Agriculture/components/AgrSearchList'
export default {
  name: 'Search',
  components: { AgrSearchList },
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      agrTypeOptions,
      popup: {
        list: false
      },
      form: {
        search: ''
      },
      extraParams: {
        sort: '-id',
        search: ''
      }
    }
  },
  methods: {
    handleSearch() {
      this.extraParams.search = this.form.search
      this.popup.list = true
    }
  }
}
</script>

<style lang="less" scoped>
.van-nav-bar {
  background: @primary-color;
  ::v-deep {
    .van-nav-bar__title,
    .van-nav-bar__left .van-icon {
      color: #fff;
    }
  }
}
.search-btn {
  display: block;
  width: 300px;
  height: 40px;
  margin: 20px auto;
  background: @primary-color;
  border-color: @primary-color;
}
</style>
